import React from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import API from "../../api/axiosConfig";

export default function ProjectDetailPage() {
  const { id } = useParams();

  const [project, setProject] = useState(); // Holds detailed project information
  const [loading, setLoading] = useState(true); // Initializes the loading state as true
  const [error, setError] = useState(null); // Intializes the error state as none

  // Fetch project details using the `id` (optional step, depending on your app)
  // You could replace the mock data below with a real API call
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        // Fetch project details
        const detailsResponse = await API.post("/api/projects/details", {
          projectIds: [id], // Send the project id parameter
        });

        // Updates the project and loading states
        // Gets the first object present in the details data JSON.
        if (detailsResponse.data && detailsResponse.data.length > 0) {
          setProject(detailsResponse.data[0]);
        } else {
          setError("Project not found.");
        }
      } catch (err) {
        if (err.response?.status !== 401) {
          // Returns an error and finishes loading.
          console.error("Error:", err);
          setError("Failed to fetch project details. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [id]);

  // Display loading message
  if (loading) {
    return <Box sx={{ padding: "16px" }}>Loading project information...</Box>;
  }
  // Display error message
  if (error) {
    return (
      <Box sx={{ padding: "16px" }}>
        <h3>{error}</h3>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "16px" }}>
      <Typography variant="h4" component="h1">
        {project?.title}
      </Typography>
      <Typography variant="body1" sx={{ marginTop: "8px" }}>
        {project?.description}
      </Typography>
      <Typography
        variant="caption"
        display="block"
        sx={{ marginTop: "12px", fontStyle: "italic", color: "gray" }}
      >
        Last Updated: {project?.lastUpdated}
      </Typography>
    </Box>
  );
}
